import { fetchApi } from "@/services/api"
import { mockSmithersGlobalService } from "@/mocks/smithers-global-service"
import type { SmithersGlobalConfig, UpdateSmithersGlobalRequest } from "@/types/smithers-global"

const realSmithersGlobalService = {
  async get(): Promise<SmithersGlobalConfig> { return fetchApi<SmithersGlobalConfig>("/api/v1/config/smithers/global") },
  async update(data: UpdateSmithersGlobalRequest): Promise<SmithersGlobalConfig> {
    return fetchApi<SmithersGlobalConfig>("/api/v1/config/smithers/global", { method: "PUT", body: JSON.stringify(data) })
  },
}

export const smithersGlobalService = import.meta.env.VITE_USE_MOCKS === "true" ? mockSmithersGlobalService : realSmithersGlobalService
